import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import {skip, take} from 'rxjs/operators';
import {AuthService} from '../auth.service';

export function AppConfigLoader(store: Store<any>, auth: AuthService): Function {
  return (): Promise<any> => {
    return new Promise((resolve, reject) => {
      if (auth.loggedIn()) {
        store.dispatch(new fromStore.LoadUser());
      }
      store.dispatch(new fromStore.GetConfig());
      store.select(s => s.config).pipe(skip(1), take(1)).subscribe(r => {
        if (r.error) {
          reject(r.error);
          return;
        }
        resolve();
        return;
      });
    });
  };
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shared/app-config.loader.ts